export const environment = "live";

const Production_URL = "";
const Sandbox_URL = "http://localhost:8113";

export const environmentVariable = {
  apiURL: environment == "sandbox" ? Sandbox_URL : Production_URL,
};

export const apiRoutes = {
  "admin/hotels": "/api/admin/hotels",
  "admin/hotel/update": "/api/admin/hotel/update",
  "admin/resetJudges": "/api/admin/settings/resetjudges",
  "admin/assignNominationsToJudges": "/api/admin/judges/assign-nominations",
  "admin/hashNominationIdentifiers": "/api/admin/nominations/hash-identifiers",
  "admin/judgeNotification": "/api/judge/notification",
  "admin/judgeReminder": "/api/judge/reminder",
  "admin/syncHotels": "/api/admin/hotels/sync",
  "admin/settings": "/api/v1/options",
  dev: {
    auth: "http://localhost:8991/checkauth",
    verifyToken: "http://localhost:8991/verifyToken",
    login: "http://localhost:8991/login",
    logout: "http://localhost:8991/logout",
    register: "http://localhost:8991/register",
    hotels: "http://localhost:8991/hotels",
    updateprofile: "http://localhost:8991/updateprofile",
    getprofile: "http://localhost:8991/getprofile",
    hotelAdmin: "http://localhost:8991/hotelAdmin",
    updateNomination: "http://localhost:8991/nomination/update",
    hashNomination: "http://localhost:8991/nomination/hash",
    nominations: "http://localhost:8991/nominations",
    nominationsNavigation: "http://localhost:8991/nominations/navigation",
    nominationsJudgeAssignmentList:
      "http://localhost:8991/nominations/judge-assignment-list",
    mynominations: "http://localhost:8991/my/nominations",
    getnomination: "http://localhost:8991/api/get/nomination",
    deleteNomination: "http://localhost:8991/api/delete/nomination",
    passwordResetRequest: "http://localhost:8991/user/password-reset-request",
    passwordReset: "http://localhost:8991/user/password-reset",
    getHotel: "http://localhost:8991/hotels/view",
    searchUser: "http://localhost:8991/api/users/search",

    allmembers: "http://localhost:8991/api/users/all",
    alljudges: "http://localhost:8991/api/users/judges",
    updateStaff: "http://localhost:8991/hotels/staff/update",
    removeStaff: "http://localhost:8991/hotels/staff/remove",
    addNominationsToJudge: "http://localhost:8991/api/nomination/judge/add",
    mynominationstojudge: "http://localhost:8991/api/judge/nominations",
    updateScore: "http://localhost:8991/api/judge/score/update",
    applyforjudge: "http://localhost:8991/api/judge/apply",
    //
    shortList: "http://localhost:8991/api/final/judge/nominations",
    finalist: "http://localhost:8991/api/finalist",
    updateFinalScore: "http://localhost:8991/api/judge/final/score/update",
    //
    adminUpdateMemberHotel:
      "http://localhost:8991/api/admin/member/update/hotels",
    adminUpdateMemberRole: "http://localhost:8991/api/user/role/update",
    adminUpdateMemberAuthDisabled:
      "http://localhost:8991/api/user/auth-disabled/update",
    adminUpdateNomination: "http://localhost:8991/api/admin/nomination/update",
  },

  live: {
    auth: "/checkauth",
    verifyToken: "/verifyToken",
    login: "/login",
    logout: "/logout",
    register: "/register",
    hotels: "/hotels",
    updateprofile: "/updateprofile",
    getprofile: "/getprofile",
    hotelAdmin: "/hotelAdmin",
    updateNomination: "/nomination/update",
    hashNomination: "/nomination/hash",
    mynominations: "/my/nominations",
    nominations: "/nominations",
    nominationsNavigation: "/nominations/navigation",
    nominationsJudgeAssignmentList: "/nominations/judge-assignment-list",
    getnomination: "/api/get/nomination",
    finalist: "/api/finalist",
    deleteNomination: "/api/delete/nomination",
    passwordResetRequest: "/user/password-reset-request",
    passwordReset: "/user/password-reset",
    getHotel: "/hotels/view",
    searchUser: "/api/users/search",

    allmembers: "/api/users/all",
    alljudges: "/api/users/judges",
    updateStaff: "/hotels/staff/update",
    removeStaff: "/hotels/staff/remove",
    addNominationsToJudge: "/api/nomination/judge/add",
    mynominationstojudge: "/api/judge/nominations",
    updateScore: "/api/judge/score/update",
    applyforjudge: "/api/judge/apply",
    //final judge

    shortList: "/api/final/judge/nominations",

    updateFinalScore: "/api/judge/final/score/update",
    //admin
    adminUpdateMemberHotel: "/api/admin/member/update/hotels",
    adminUpdateMemberRole: "/api/user/role/update",
    adminUpdateMemberAuthDisabled: "/api/user/auth-disabled/update",
    adminUpdateNomination: "/api/admin/nomination/update",
  },
};
